import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { services } from "../../data";

const Services = ({ page = "home", data }) => {
  const [servicesData, setServicesData] = useState(services);
  useEffect(() => {
    if (data !== undefined) setServicesData(data);
  }, [data, servicesData]);

  return (
    <div
      className={
        page === "home"
          ? "bg-lightblue-1 flex flex-col items-center w-full pb-10 pt-4 bg-home-services"
          : "flex flex-col items-center w-full pb-10 pt-4"
      }
    >
      <div className="h-auto relative max-w-screen-xl flex flex-col items-center w-full py-6 sm:py-10 gap-10 px-5 xl:px-0">
        {page === "home" && (
          <p className="text-5xl sm:text-8xl text-blue-5">Our Services</p>
        )}
        <div className="flex w-full h-full relative z-10 justify-center items-center gap-6 flex-wrap">
          {servicesData?.map((service, index) => (
            <NavLink
              className="flex flex-col justify-center w-[46%] sm:w-[31%] shadow-lg group overflow-hidden cursor-pointer rounded"
              key={index}
              to={`/services/${service.id}`}
            >
              <img
                src={service.image}
                alt={service.id}
                className="w-full lg:h-[388px] group-hover:scale-105 group-hover:origin-center transition-all object-cover aspect-square"
              />
              <p className="lg:text-xl md:text-lg sm:text-md text-xs text-blue-6 w-full sm:h-[60px] h-[40px] flex items-center text-center justify-center group-hover:bg-blue-6 group-hover:text-white group-hover:origin-center transition-all bg-white z-10 relative duration-300 ease-in">
                {service.name}
              </p>
            </NavLink>
          ))}

          {page === "home" ? (
            <div className="flex items-center justify-center md:justify-between w-full px-3 pt-10">
              <div className="hidden md:flex items-center md:w-1/3 w-1/5">
                <div className="w-2.5 h-2.5 bg-blue-8 rotate-45 block "></div>
                <div className="w-[calc(100%-4px)] h-0.5 bg-blue-8 block"></div>
                <div className="w-2.5 h-2.5 bg-blue-8 rotate-45 block"></div>
              </div>
              <NavLink
                className="bg-blue-8 hover:bg-blue-7 text-sm  md:text-md font-light text-white md:w-[28%] w-[50%] rounded flex items-center justify-center h-10"
                to="/services"
              >
                View All Services
              </NavLink>
              <div className="hidden md:flex items-center md:w-1/3 w-1/5">
                <div className="w-2.5 h-2.5 bg-blue-8 rotate-45 block "></div>
                <div className="w-[calc(100%-4px)] h-0.5 bg-blue-8 block"></div>
                <div className="w-2.5 h-2.5 bg-blue-8 rotate-45 block"></div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Services;
